export const numberKeyPress = (e, success = undefined) => {
  // Autoriser les touches de contrôle
  if (
    e.which === 0 ||
    e.which === 8 ||
    e.which === 46 ||
    e.keyCode === 37 || // Flèche gauche
    e.keyCode === 38 || // Flèche haut
    e.keyCode === 39 || // Flèche droite
    e.keyCode === 40
  ) {
    return;
  }

  // Vérifie si le caractère n'est pas un chiffre (0-9) et empêche l'entrée
  if (!e.key.match(/[0-9]/)) {
    e.preventDefault();
    return;
  }

  if (success) success();
};

export const floatKeyPress = (e, success = undefined) => {
  // Autoriser les touches de contrôle et la virgule (pour les décimaux)
  if (
    e.which === 0 ||
    e.which === 8 || // Touche de suppression arrière
    e.which === 46 || // Touche de suppression
    e.keyCode === 37 || // Flèche gauche
    e.keyCode === 38 || // Flèche haut
    e.keyCode === 39 || // Flèche droite
    e.keyCode === 40 || // Flèche bas
    e.key === '.' // Virgule pour décimal
  ) {
    return;
  }

  // Vérifie si le caractère n'est pas un chiffre (0-9) ou une virgule et empêche l'entrée
  if (!e.key.match(/[0-9.]/)) {
    e.preventDefault();
    return;
  }

  if (success) success();
};

export const numberValueChanged = (e, error, success) => {
  const { value } = e.target;

  const regex = /^[0-9\b]+$/;

  if (value === '' || regex.test(value)) {
    success(value === '' ? '' : Math.abs(value));
  } else {
    if (error) error();
  }
};

export const floatValueChanged = (e, error, success) => {
  const { value } = e.target;

  const regex = /^\d+(\.\d{1,2})?$/;

  if (value === '' || regex.test(value)) {
    success(value === '' ? '' : Math.abs(value));
  } else {
    if (error) error();
  }
};
